import { render } from "./EditCustomer.vue?vue&type=template&id=6ab30ca1&ts=true"
import script from "./EditCustomer.vue?vue&type=script&lang=ts"
export * from "./EditCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__